module.exports = __webpack_public_path__ + "static/media/ic-search.027fb8c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-search.svg
// module id = 219
// module chunks = 0